// AdminMenu.tsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Import all icons from Option 1
import { 
  Users, 
  CreditCard, 
} from 'lucide-react'; 

interface AdminMenuProps {
  isMobile?: boolean;
}

// Extracted links to a separate component to avoid repetition
const MenuLinks: React.FC = () => {
  const { t } = useTranslation();

  // Classes based on Option 1's design
  const baseLinkClasses = "flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-muted-foreground transition-all hover:text-primary";
  const activeLinkClasses = "bg-muted text-primary";

  return (
    <nav className="grid gap-2 text-sm font-medium">
      {/* Added Overview and Settings links from Option 1 */}

      <NavLink 
          to="/admin/users" 
          className={({ isActive }) => `${baseLinkClasses} ${isActive ? activeLinkClasses : ''}`}
      >
          <Users className="h-5 w-5" />
          {t('admin.menu.users')}
      </NavLink>

      <NavLink 
          to="/admin/billing" 
          className={({ isActive }) => `${baseLinkClasses} ${isActive ? activeLinkClasses : ''}`}
      >
          <CreditCard className="h-5 w-5" />
          {t('admin.menu.billing')}
      </NavLink>
      
      { /* Updated styling for commented-out link */ }
      { /*}
      <NavLink 
          to="/admin/organization" 
          className={({ isActive }) => `${baseLinkClasses} ${isActive ? activeLinkClasses : ''}`}
      >
          <Building2 className="h-5 w-5" />
          {t('admin.menu.organization')}
      </NavLink>
      */}

    </nav>
  );
}

export const AdminMenu: React.FC<AdminMenuProps> = ({ isMobile = false }) => {
  const { t } = useTranslation();

  // Render for mobile (just the links, for the Sheet)
  if (isMobile) {
    return (
      <div className="mt-6"> {/* Add spacing in the mobile sheet */}
        <MenuLinks />
      </div>
    );
  }

  // Render for desktop (full <aside> sidebar)
  // Uses responsive widths from the *original* layout to prevent regression
  return (
      <aside className="hidden border-r bg-background md:block md:w-[180px] lg:w-[250px]">
          <div className="flex h-full max-h-screen flex-col gap-2 p-4 lg:p-6">
              {/* Title from Option 1 */}
              <div className="mb-3">
                  <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                      {t('admin.layout.title')}
                  </h2>
              </div>
              <MenuLinks />
          </div>
      </aside>
  );
};